import {createSelector} from 'reselect'

const exportReportSelector = (state) => state.exportReport; 

export const selectExportData = createSelector(
    [exportReportSelector],
    (exportReport) => exportReport.exportData
);
